import React from 'react'

const Socialforum = () => {
  return (
    <div>Socialforum</div>
  )
}

export default Socialforum